import axios from 'axios';

import {
    API_BASE_URL
} from '../../constants/index';

export default class SupplierProductService {
    static instance;

    static getInstance() {
        if (!SupplierProductService.instance) {
            SupplierProductService.instance = new SupplierProductService();
        }

        return SupplierProductService.instance;
    }

    async list(supplierId, params = {}) {
        const response = await axios.get(`${API_BASE_URL}/supplier/${supplierId}/products`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            },
        });
        return response.data?.data || null;
    }

    async create(payload) {
        const response = await axios.post(`${API_BASE_URL}/supplier/product/add`, payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                },
            }
        );

        return response.data?.data || null;
    }

    async update(productId, payload) {
        const response = await axios.put(`${API_BASE_URL}/supplier/product/${productId}/edit`, payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                },
            }
        );

        return response.data?.data || null;
    }

    async show(productId, params = {}) {
        const response = await axios.get(`${API_BASE_URL}/supplier/product/${productId}`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });
        return response.data?.data || null;
    }

    async delete(productId) {
        const response = await axios.delete(`${API_BASE_URL}/supplier/product/${productId}/delete`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                },
            }
        );

        return response.data?.data || null;
    }

    async fetchGeoCledianResult(supplierId, params = {}) {
        // const response = await axios.get(`${API_BASE_URL}/eudr/geolocation/get-result`, {
        //     params: params,
        //     headers: {
        //         Authorization: `Bearer ${localStorage.getItem(
        //             "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        //         )}`
        //     }
        // });

        // return response.data?.data || null;

        if (params.product_id % 2 === 1) {
            return {
                "parcel_id": 47707,
                "name": "Vera Cruz",
                "entity": "Ghana",
                "foreign_id": null,
                "commodity": "Cocoa",
                "production_start": "2020-11-01",
                "production_end": "2024-01-31",
                "country_iso": "GH",
                "country_risk": "low",
                "area_rep": null,
                "area": 107.06,
                "geohash": "7jk0vj2",
                "point_buffer_area": null,
                "validation": null,
                "userdata": {},
                "geometry": {
                    "type": "Polygon",
                    "coordinates": [
                        [
                            [
                                -1.259608,
                                8.811024
                            ],
                            [
                                -1.25433,
                                8.816028
                            ],
                            [
                                -1.247807,
                                8.815392
                            ],
                            [
                                -1.246433,
                                8.809252
                            ],
                            [
                                -1.248364,
                                8.808955
                            ],
                            [
                                -1.250038,
                                8.808446
                            ],
                            [
                                -1.251497,
                                8.80781
                            ],
                            [
                                -1.253214,
                                8.807386
                            ],
                            [
                                -1.256604,
                                8.80798
                            ],
                            [
                                -1.261411,
                                8.807216
                            ],
                            [
                                -1.259608,
                                8.811024
                            ]
                        ]
                    ]
                },
                "raw_response": {
                    "type": "Feature",
                    "geometry": {
                        "type": "Polygon",
                        "coordinates": [
                            [
                                [
                                    -1.259608,
                                    8.811024
                                ],
                                [
                                    -1.25433,
                                    8.816028
                                ],
                                [
                                    -1.247807,
                                    8.815392
                                ],
                                [
                                    -1.246433,
                                    8.809252
                                ],
                                [
                                    -1.248364,
                                    8.808955
                                ],
                                [
                                    -1.250038,
                                    8.808446
                                ],
                                [
                                    -1.251497,
                                    8.80781
                                ],
                                [
                                    -1.253214,
                                    8.807386
                                ],
                                [
                                    -1.256604,
                                    8.80798
                                ],
                                [
                                    -1.261411,
                                    8.807216
                                ],
                                [
                                    -1.259608,
                                    8.811024
                                ]
                            ]
                        ]
                    },
                    "properties": {
                        "parcel_id": 47707,
                        "name": "Vera Cruz",
                        "entity": "Ghana",
                        "foreign_id": null,
                        "commodity": "Cocoa",
                        "production_start": "2020-11-01",
                        "production_end": "2024-01-31",
                        "country_iso": "GH",
                        "country_risk": "low",
                        "area_rep": null,
                        "area": 107.06,
                        "geohash": "7jk0vj2",
                        "point_buffer_area": null,
                        "validation": null,
                        "userdata": {}
                    },
                    "id": 47707,
                    "bbox": [
                        -15.312219064814046,
                        -39.16033527777777,
                        -15.302402499999998,
                        -39.14892683758847
                    ]
                }
            }
        }

        return {
            "product_id": 3876,
            "parcel_id": "50897",
            "commodity": "Cocoa",
            "name": "Estancia La Gringa 2",
            "production_end": "2024-03-01",
            "country_iso": "CI",
            "area": "78.36",
            "geohash": "6ezup70",
            "deforestation_risk": "high",
            "deforestation_area_ha": "20.91",
            "deforestation_index": "26.71",
            "baseline_date": "2020-12-31",
            "sdate": "2024-02-27",
            "landcover_forest_coverage": "0.2",
            "landcover_plantation_coverage": "0.1",
            "landcover_shrubs_coverage": "0.5",
            "landcover_no_trees_coverage": "0.2",
            "landcover_png_baseline_date": "/eudr/parcels/50897/risk/1/landcover_mask.png",
            "rgb_png_baseline_date": "/parcels/50897/visible/sentinel2/3588894.png",
            "rgb_png_production_enddate": "/parcels/50897/visible/sentinel2/3588882.png",
            "forest_change_png": "/eudr/parcels/50897/risk/1/forest_change.png",
            "country_risk": "medium",
            "model_version": "1.2.6",
            "generation_date": "2025-08-19 09:39:00",
            "map_utils_landcover_legend_png": "/eudr/parcels/50897/risk/1/landcover_mask.png?legend=true",
            "map_utils_forest_change_legend_png": "/eudr/parcels/50897/risk/1/forest_change.png?legend=true",
            "map_utils_scalebar": "/eudr/parcels/50897/risk/1/landcover_mask.png?scale=true",
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [
                            -6.816888,
                            8.619805
                        ],
                        [
                            -6.821405,
                            8.617057
                        ],
                        [
                            -6.823411,
                            8.618829
                        ],
                        [
                            -6.824098,
                            8.623029
                        ],
                        [
                            -6.823969,
                            8.623496
                        ],
                        [
                            -6.823797,
                            8.623878
                        ],
                        [
                            -6.82354,
                            8.624133
                        ],
                        [
                            -6.823454,
                            8.624302
                        ],
                        [
                            -6.823239,
                            8.624387
                        ],
                        [
                            -6.823111,
                            8.624642
                        ],
                        [
                            -6.822209,
                            8.625618
                        ],
                        [
                            -6.820664,
                            8.62566
                        ],
                        [
                            -6.819205,
                            8.625618
                        ],
                        [
                            -6.817017,
                            8.625396
                        ],
                        [
                            -6.813927,
                            8.62476
                        ],
                        [
                            -6.812596,
                            8.622266
                        ],
                        [
                            -6.816888,
                            8.619805
                        ]
                    ]
                ]
            },
            "raw_response": {
                "id": 50897,
                "bbox": [
                    -23.190943094244396,
                    -56.288347396999995,
                    -23.182636441,
                    -56.27566882099539
                ],
                "type": "Feature",
                "geometry": {
                    "type": "Polygon",
                    "coordinates": [
                        [
                            [
                                -6.816888,
                                8.619805
                            ],
                            [
                                -6.821405,
                                8.617057
                            ],
                            [
                                -6.823411,
                                8.618829
                            ],
                            [
                                -6.824098,
                                8.623029
                            ],
                            [
                                -6.823969,
                                8.623496
                            ],
                            [
                                -6.823797,
                                8.623878
                            ],
                            [
                                -6.82354,
                                8.624133
                            ],
                            [
                                -6.823454,
                                8.624302
                            ],
                            [
                                -6.823239,
                                8.624387
                            ],
                            [
                                -6.823111,
                                8.624642
                            ],
                            [
                                -6.822209,
                                8.625618
                            ],
                            [
                                -6.820664,
                                8.62566
                            ],
                            [
                                -6.819205,
                                8.625618
                            ],
                            [
                                -6.817017,
                                8.625396
                            ],
                            [
                                -6.813927,
                                8.62476
                            ],
                            [
                                -6.812596,
                                8.622266
                            ],
                            [
                                -6.816888,
                                8.619805
                            ]
                        ]
                    ]
                },
                "properties": {
                    "area": 78.36,
                    "name": "Estancia La Gringa 2",
                    "sdate": "2024-02-27",
                    "entity": "Côte d'Ivoire",
                    "geohash": "6ezup70",
                    "commodity": "Cocoa",
                    "parcel_id": 50897,
                    "check_date": "2024-03-01",
                    "country_iso": "CI",
                    "country_risk": "medium",
                    "baseline_date": "2020-12-31",
                    "model_version": "1.2.6",
                    "production_end": "2024-03-01",
                    "generation_date": "2025-08-19T09:39:00",
                    "production_start": "2019-12-31",
                    "forest_change_png": "/eudr/parcels/50897/risk/1/forest_change.png",
                    "deforestation_risk": "high",
                    "map_utils_scalebar": "/eudr/parcels/50897/risk/1/landcover_mask.png?scale=true",
                    "deforestation_index": 26.71,
                    "deforestation_area_ha": 20.91,
                    "rgb_png_baseline_date": "/parcels/50897/visible/sentinel2/3588894.png",
                    "landcover_forest_coverage": 1,
                    "landcover_shrubs_coverage": 0,
                    "deforestation_index_shrubs": 0,
                    "rgb_png_production_enddate": "/parcels/50897/visible/sentinel2/3588882.png",
                    "deforestation_index_natural": 26.71,
                    "deforestation_index_planted": 0,
                    "landcover_no_trees_coverage": 0,
                    "landcover_png_baseline_date": "/eudr/parcels/50897/risk/1/landcover_mask.png",
                    "deforestation_area_ha_shrubs": 5,
                    "deforestation_area_ha_natural": 5.91,
                    "deforestation_area_ha_planted": 10,
                    "landcover_plantation_coverage": 0,
                    "map_utils_landcover_legend_png": "/eudr/parcels/50897/risk/1/landcover_mask.png?legend=true",
                    "map_utils_forest_change_legend_png": "/eudr/parcels/50897/risk/1/forest_change.png?legend=true"
                }
            },
            "result_fetched_at": "2025-10-09 11:54:02"
        }

    }

    async updateGeoLocation(productId, payload) {
        const response = await axios.put(`${API_BASE_URL}/supplier/product/${productId}/geolocation`, payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data?.data || null;
    }

    async validateGeoLocation(payload) {
        const response = await axios.post(`${API_BASE_URL}/eudr/validate_geolocation`, payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data?.data || null;
    }
}
